import style from "styled-components";

export const ContainerRatings = style.div`
   display:flex;
   flex-direction:row;
   justify-content:center;
   margin-top:1.0rem;
`;

export const IconStar = style.img`
  width:20px;
  margin-right:2px;
`;

export const NumbReviews = style.span`
  font-size:${({ theme }) => theme.fontSizes.small};
`;
